var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgPopular = function SvgPopular(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85035 8.19469C5.70188 8.49874 4.33215 6.49976 5.24564 4.76127C0.74627 9.28429 4.8707 16.8227 10.4949 13.8073C14.9943 10.792 11.4948 4.76127 8.99512 2.49976C10.4949 5.89202 9.99882 7.89064 7.85035 8.19469Z",
    fill: "#763B93",
    stroke: "#763B93",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24496 10.122C7.23449 10.4568 6.9973 11.7567 7.23396 12.4688C7.56813 13.4744 8.72699 13.4743 9.58149 13.0745C11.5932 12.1332 11.6959 9.22616 10.9206 7.77471C10.9209 8.78044 10.2521 9.95421 9.24496 10.122Z",
    fill: "#F2ECF5",
    stroke: "#F2ECF5",
    strokeLinejoin: "round"
  })));
};
var Memo = /*#__PURE__*/memo(SvgPopular);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/images/tags/popular.4088bc754ef75377b09f0988de5139ac.svg";